import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import {
  HomeIcon,
  DocumentTextIcon,
  CreditCardIcon,
  BellIcon,
  Bars3Icon
} from '@heroicons/react/24/outline'
import {
  HomeIcon as HomeIconSolid,
  DocumentTextIcon as DocumentTextIconSolid,
  CreditCardIcon as CreditCardIconSolid,
  BellIcon as BellIconSolid
} from '@heroicons/react/24/solid'

const BottomNavigation = ({ onMenuClick }) => {
  const location = useLocation()

  const navItems = [
    {
      name: 'Início',
      href: '/dashboard',
      icon: HomeIcon,
      iconActive: HomeIconSolid
    },
    {
      name: 'Contratos',
      href: '/contracts',
      icon: DocumentTextIcon,
      iconActive: DocumentTextIconSolid
    },
    {
      name: 'Faturas',
      href: '/invoices',
      icon: CreditCardIcon,
      iconActive: CreditCardIconSolid
    },
    {
      name: 'Alertas',
      href: '/notifications',
      icon: BellIcon,
      iconActive: BellIconSolid
    }
  ]

  const isActive = (href) => {
    return location.pathname === href || location.pathname.startsWith(href + '/')
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-50 lg:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const active = isActive(item.href)
          const Icon = active ? item.iconActive : item.icon

          return (
            <NavLink
              key={item.href}
              to={item.href}
              className={`
                flex flex-col items-center justify-center flex-1 h-full px-1 py-2
                transition-colors duration-200
                ${active
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-gray-500 dark:text-gray-400'
                }
              `}
            >
              <Icon className={`w-6 h-6 ${active ? 'scale-110' : ''} transition-transform`} />
              <span className={`text-xs mt-1 font-medium ${active ? 'font-semibold' : ''}`}>
                {item.name}
              </span>
            </NavLink>
          )
        })}

        {/* Menu Button */}
        <button
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center flex-1 h-full px-1 py-2 text-gray-500 dark:text-gray-400"
        >
          <Bars3Icon className="w-6 h-6" />
          <span className="text-xs mt-1 font-medium">Menu</span>
        </button>
      </div>
    </nav>
  )
}

export default BottomNavigation
